import React, { useState, useContext } from 'react';
import { Modal, Button, Input } from 'antd';
import { ModalBody, ModalContainer, InputLabel, Container } from './styles';
import { updateCategory } from '../../utils/services/categoriesAPI';
import { DESIGN_AREA_SETTINGS_TAB } from '../../containers/SidebarMenu/translationValues';
import { useTranslation } from 'react-i18next';
// app store context API
import { AppStoreContext } from '../../context/appStoreContext';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];
const UpdateCategoryModal = props => {
  const { visible, onCancel, categoryType, categoryDetails } = props;
  const { t } = useTranslation(NAMESPACES);
  const [categoryName, setNewCategoryName] = useState(
    categoryDetails && categoryDetails.name ? categoryDetails.name : '',
  );
  const [validCategName, setValidCategName] = useState(false);
  const [savingLoader, setSavingLoader] = useState(false);
  const { updateCategoryElements, updateCategoryTemplates } = useContext(AppStoreContext);

  const saveCategory = () => {
    setSavingLoader(true);
    let payload = {
      name: categoryName,
      type: categoryType,
      id: categoryDetails.id,
    };
    updateElementCategory(payload);
  };

  const updateElementCategory = async payload => {
    let categoryResponse = await updateCategory(payload);
    if (categoryResponse && categoryResponse.errors && categoryResponse.errors.length === 0) {
      const savedCategory = {
        createdBy: null,
        createdOn: null,
        elements: [],
        id: categoryResponse.id,
        name: payload.name,
        parentId: 0,
        status: 'active',
        type: categoryType,
        updatedBy: null,
        updatedOn: null,
      };
      if (categoryType === 'element') {
        updateCategoryElements(savedCategory, 'updateElementCategory');
      } else {
        updateCategoryTemplates(savedCategory, 'updateTemplateCategory');
      }
      setSavingLoader(false);
      onCancel();
    }
    else {
      setSavingLoader(false);
    }
  };

  const setCategoryName = categoryName => {
    setNewCategoryName(categoryName);
    setValidCategName(categoryName.split(" ").join("").length);
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={t(DESIGN_AREA_SETTINGS_TAB.UPDATE_CATEGORY_MODAL_TITLE.key, DESIGN_AREA_SETTINGS_TAB.UPDATE_CATEGORY_MODAL_TITLE.value)}
        maskClosable={false}
        centered
        visible={visible}
        width="625px"
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel}>
            {t(DESIGN_AREA_SETTINGS_TAB.CANCEL_UPDATING_CATEGORY_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.CANCEL_UPDATING_CATEGORY_BUTTON.value)}
          </Button>,
          <Button
          key="submit"
          type="primary"
          disabled={!categoryName || categoryName === categoryDetails.name || !validCategName}
          loading={savingLoader}
          onClick={() => saveCategory()}
        >
          {savingLoader
            ? t(DESIGN_AREA_SETTINGS_TAB.SAVING_UPDATED_CATEGORY_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.SAVING_UPDATED_CATEGORY_BUTTON.value)
            : t(DESIGN_AREA_SETTINGS_TAB.SAVE_UPDATED_CATEGORY_BUTTON.key, DESIGN_AREA_SETTINGS_TAB.SAVE_UPDATED_CATEGORY_BUTTON.value)}
        </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <ModalContainer>
            <InputLabel>{t(DESIGN_AREA_SETTINGS_TAB.NEW_CATEGORY_NAME_LABEL.key, DESIGN_AREA_SETTINGS_TAB.NEW_CATEGORY_NAME_LABEL.value)}</InputLabel>
            <Input
              placeholder={t(DESIGN_AREA_SETTINGS_TAB.NEW_CATEGORY_PLACEHOLDER.key, DESIGN_AREA_SETTINGS_TAB.NEW_CATEGORY_PLACEHOLDER.value)}
              autoComplete="off"
              name="categoryName"
              onChange={e => setCategoryName(e.target.value)}
              size="large"
              defaultValue={categoryDetails && categoryDetails.name ? categoryDetails.name : ''}
            />
          </ModalContainer>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default UpdateCategoryModal;
